import { clientRouteConfig } from 'client/shared/routeTargets'
import DownloadRoute from 'client/pages/Download'
import { createBrowserRouter, redirect } from 'react-router-dom'
import Impersonate from 'shared/pages/Impersonate'
import Logout from 'shared/pages/Logout'
import {
    ForgotPasswordForm,
    ResetPasswordForm,
} from 'shared/pages/SignUpSignIn/ForgotResetPassword/'
import SignIn from 'shared/pages/SignUpSignIn/SignIn'
import SignUp from 'shared/pages/SignUpSignIn/SignUp'
import 'shared/style/App.scss'
import { candidateRouteConfig } from '../candidate/routes'
import { recruiterRouteConfig } from '../recruiter/routes'
import ErrorBoundary from './components/ErrorBoundary'
import { RouteContainer } from './components/RouteContainer'
import { preloadQuery } from './graphql/client'
import { getUser } from './graphql/user.gql'
import { commonRouteConfig } from './routeConfig'
import { checkAuth, setToken } from './utils/auth'
import { getProtectedRoutes, getSubdomain } from './utils/routing'

// fallback value existing due to config import error in jest
export const noBreadcrumbPaths = [
    candidateRouteConfig?.intakes.intake.path || '/intakes/intake',
    candidateRouteConfig?.intakes.complete.path || '/intakes/complete',
    recruiterRouteConfig?.candidates.path || '/people',
    recruiterRouteConfig?.companies.path || '/companies',
    recruiterRouteConfig?.research.path || '/research',
    recruiterRouteConfig?.rosters.path || '/searches',
    candidateRouteConfig?.jobboards.path || '/job',
    clientRouteConfig?.searches.path || '/searches',
    clientRouteConfig?.mappings.path || '/mappings',
]

export { commonRouteConfig }

const subdomain = getSubdomain(process.env.REACT_APP_DOMAIN)

export const router = createBrowserRouter([
    {
        path: commonRouteConfig.login.path,
        element: <SignIn />,
        loader: () => {
            // if user is already logged in, redirect to base route
            const isSignedIn = checkAuth()
            if (isSignedIn) {
                return redirect(commonRouteConfig.index.path)
            }
            return null
        },
    },
    {
        path: commonRouteConfig.register.path,
        element: <SignUp />,
    },
    {
        path: commonRouteConfig.forgotPassword.path,
        element: <ForgotPasswordForm />,
    },
    {
        path: commonRouteConfig.resetPassword.path,
        element: <ResetPasswordForm />,
    },
    {
        path: commonRouteConfig.logout.path,
        element: <Logout />,
    },
    {
        path: '/impersonate',
        element: <Impersonate />,
    },
    {
        path: '/download/:type/:id',
        element: <DownloadRoute />,
    },
    {
        path: '/d/:type/:id',
        element: <DownloadRoute />,
    },
    {
        path: '/',
        element: <RouteContainer />,
        errorElement: <ErrorBoundary />,
        loader: async ({ request }) => {
            if (!subdomain) {
                // this should only happen locally since we will only have subdomains in higher envs
                return redirect('http://candidate.localhost:3000')
            }
            const token = new URL(request.url).searchParams.get('token')
            if (token) {
                setToken(token)
            }
            const queryRef = await preloadQuery(getUser, {
                context: {
                    headers: {
                        authorization: token ? `Bearer ${token}` : undefined,
                    },
                },
            }).toPromise()
            return queryRef
        },
        children: [...getProtectedRoutes(subdomain)],
    },
])
